import * as React from 'react';
import Card from '@mui/material/Card';
import { ServiceApi } from "../../services/index.service";
import { useDispatch, useSelector } from "react-redux";

import "./cards.css";
import { SuccessPopup } from './SuccessPopup';
import { CircularProgress, Backdrop } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { removeAllFromCart } from "../../redux/purchaseRequest/purchaseRequestSlice";

export default function PurchaseTotal(props) {
    const navigate = useNavigate();

    const dispatch = useDispatch();
    const data = useSelector((state) => state);
    const { addedItems } = data?.purchaseRequest;
    console.log("addedItems",addedItems);

    const [loading, setLoading] = React.useState(false);
    const [itemsInformation, setItemsInformation] = React.useState(addedItems);
    const [itemsSubTotal, setItemsSubTotal] = React.useState(0);
    const [shippingAmount, setShippingAmount] = React.useState(0);
    const [taxAmount, setTaxAmount] = React.useState(0);
    const [totalAmount, setTotalAmount] = React.useState(0);
    const { storage } = useSelector((state) => state);
    const [openDialog, setOpenDialog] = React.useState(false);

    const { enqueueSnackbar } = useSnackbar();
   
    React.useEffect(() => {
        clculateNewAmounts();
    }, [addedItems])

    const clculateNewAmounts = () => {
        if (addedItems.length > 0) {
            let newItemsSubTotal = 0,
                itemsData = [];
            for (let i = 0; i < addedItems.length; i++) {
                //INSTEAD OF 4 ATTRIBUTES IN PRODUCT SEND THE ENTIRE PRODUCT IN PAYLOAD
                /* const item = {
                    product_id: addedItems[i].id,
                    quantity: addedItems[i].quantity,
                    category_id: addedItems[i].category_id,
                    description: addedItems[i].description,
                    img_thumbs: addedItems[i].img_thumbs
                } */
                itemsData.push(addedItems[i])
                newItemsSubTotal = newItemsSubTotal + Number(addedItems[i].subtotal);
            }
            newItemsSubTotal = newItemsSubTotal.toFixed(2);
            // const newShippingAmount = ((newItemsSubTotal * 1) / 100).toFixed(2);
            // const newTaxAmount = ((newItemsSubTotal * 13) / 100).toFixed(2);
            const newShippingAmount = ((newItemsSubTotal));
            const newTaxAmount = ((newItemsSubTotal));
            // const newTotalAmount = (Number(newItemsSubTotal) + Number(newShippingAmount) + Number(newTaxAmount)).toFixed(2);
            const newTotalAmount = (Number(newItemsSubTotal)).toFixed(2);

            setItemsInformation(itemsData);
            setItemsSubTotal(newItemsSubTotal);
            setShippingAmount(newShippingAmount);
            setTaxAmount(newTaxAmount);
            setTotalAmount(newTotalAmount);
        }
    }

    const serviceapi = new ServiceApi();
    const getPurchaseMerchendiseOrders = async () => {
        const requestBody = {
            user_id: data?.profile?.uid,
            store_id: storage?.store?.intStoreID,
            items_data: itemsInformation,
            sub_total: itemsSubTotal,
            shipping: shippingAmount,
            tax: taxAmount,
            total: totalAmount,
            status: 1,
        }
        if (!storage?.store?.intStoreID) {
            enqueueSnackbar("Please select store", {
                anchorOrigin: {
                    vertical: "top",
                    horizontal: "right",
                },
                variant: "error",
            });
            return false
        } else {
            setLoading(true)
            const response = await serviceapi?.createMerchandiseOrder(requestBody);
            console.log("response after submit request", response);
            if (response) {
                setLoading(false);
                setOpenDialog(true)
            } else {
                setLoading(false);
            }
        }

    };

    const handleSubmitRequest = () => {
        getPurchaseMerchendiseOrders();
    }

    const handleConfirmDialog = () => {
        setOpenDialog(!openDialog);
        console.log("navigate to main")
        // clear Items from cart after successfull submit request
        dispatch(removeAllFromCart());
        if(props?.directUrl){
            navigate("/buy-merchandise");
        }else{
            navigate("/admin");
        }
    }

    return (
        <>
            <Backdrop
                sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={loading}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <SuccessPopup openDialog={openDialog} handleConfirmDialog={handleConfirmDialog} />
            <div className="purchase_request_total">
                {/* style={{ height: "80vh" }} */}
                <Card >
                    <div className="purchase_total_details">
                        <div className="Purchase_subTotal btn_border">
                            <span >Subtotal:</span>
                        </div>
                        <div className="Purchase_subTotal btn_border">
                            <span >${itemsSubTotal}</span>
                        </div>
                    </div>
                    <div className="purchase_total_details ">
                        <div className="Purchase_subTotal">
                            <span >Total:</span>
                        </div>
                        <div className="Purchase_subTotal">
                            <span >${totalAmount}</span>
                        </div>
                        {/* {<span>total: ${totalAmount}</span>} */}
                    </div>
                    <div style={{ display: "flex", justifyContent: "flex-start", fontSize: "10px", margin: "12px" }}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 10 25 4" fill="currentColor" className="w-35 h-5">
                            <path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a.75.75 0 000 1.5h.253a.25.25 0 01.244.304l-.459 2.066A1.75 1.75 0 0010.747 15H11a.75.75 0 000-1.5h-.253a.25.25 0 01-.244-.304l.459-2.066A1.75 1.75 0 009.253 9H9z" clipRule="evenodd" />
                        </svg>
                        <h1>
                            Shops will be billed for the merchandise, tax & shipping and handling through the standard ACH billing terms.
                            Shipping and Tax will be calculated based on the Federal Income Tax.
                            Order quantities are limited and replenishment of items are not guaranteed.
                        </h1>
                    </div>
                    <div className="purchase_total_details">
                        <button className="purchase_total_submit_btn" onClick={handleSubmitRequest} >Submit Request</button>
                    </div>
                </Card>
            </div>
        </>
    );
}